import { Avatar, ButtonBase, Fade, Tooltip } from '@mui/material';

import { UserProfilePictureDialog } from '~/components/Dialogs/UserProfilePictureDialog';
import { useLibraryComponentContext } from '~/library/components/LibraryComponentContext';

import { ChangeLanguage } from '../ChangeLanguage';
import { LegacyChangePassword } from '../LegacyChangePassword';

import { UserProfileOptions } from './components/UserProfileOptions';
import { useLegacyUserProfile } from './useLegacyUserProfile';
import { useSxStyles } from './useStyles';

export const LegacyUserProfile = () => {
  const sxStyles = useSxStyles();

  const { onUpdateLegacy } = useLibraryComponentContext();

  const {
    employeeProfile,
    lastLoginTime,
    openDialogName,
    dialogOpenChange,
    resetDialog,
  } = useLegacyUserProfile();

  return (
    <>
      <Tooltip
        placement="bottom-end"
        leaveDelay={0}
        TransitionComponent={Fade}
        componentsProps={{
          popper: {
            sx: sxStyles.popper,
          },
        }}
        title={
          <UserProfileOptions
            lastLogin={lastLoginTime}
            employeeProfile={employeeProfile}
            onChangeLanguage={() => dialogOpenChange('changeLanguage')}
            onChangePassword={() => dialogOpenChange('changePassword')}
            onChangePicture={() => dialogOpenChange('changePicture')}
          />
        }
      >
        <ButtonBase
          aria-controls="user-profile-menu"
          aria-haspopup="true"
          sx={{ overflow: 'hidden' }}
        >
          <Avatar
            variant="rounded"
            alt={`${employeeProfile.firstName} ${employeeProfile.lastName}`}
            src={employeeProfile.profilePic}
          />
        </ButtonBase>
      </Tooltip>
      <UserProfilePictureDialog
        open={openDialogName === 'changePicture'}
        onClose={resetDialog}
        onUpdateLegacy={onUpdateLegacy}
      />
      {openDialogName === 'changePassword' && (
        <LegacyChangePassword resetDialog={resetDialog} />
      )}
      {openDialogName === 'changeLanguage' && (
        <ChangeLanguage resetDialog={resetDialog} />
      )}
    </>
  );
};
